if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if(this.form != null){
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.selectButton = this.querySelector('.button-select');
          this.stickySelectButton = document.querySelector('.sticky-select');
          if(this.submitButton != null){
            this.submitButtonText = this.submitButton.querySelector('span');
    
            if (document.querySelector('cart-drawer'))
              this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.fetchAddToCart(config)
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                {once: true},
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            window.dispatchEvent(new CustomEvent('abra:render'));
          })
          .catch((e) => {
            console.error(e);
            if (!e.cooldownMs) return;
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: e.message,
              message: e.message,
            });
            this.handleErrorMessage(window.cartStrings.error);
            this.cooldownUntil = Date.now() + e.cooldownMs;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.closest(
              'dialog.complete-the-look__quick-add-dialog--mobile',
            )?.classList.add('hidden');

            // Keep the button blocked during the cooldown to avoid retry spam (429)
            const wait = Math.max(0, (this.cooldownUntil || 0) - Date.now());
            setTimeout(() => {
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }, wait);
          });
      }

      // POST /cart/add, retrying automatically on 429. A 429 means Shopify rejected
      // the request without processing it, so retrying cannot add the item twice.
      // 5xx is NOT retried (the item may already be in the cart).
      // 422 (sold out, inventory) is returned as JSON for the response.status branch.
      async fetchAddToCart(config) {
        const MAX_RETRIES = 2;
        const MAX_DELAY_MS = 5000;

        for (let attempt = 0; ; attempt += 1) {
          const response = await fetch(`${routes.cart_add_url}`, config);

          if (response.status === 429 || response.status >= 500) {
            const retryAfter = Number(response.headers.get('Retry-After'));
            const delayMs = Math.min(
              retryAfter > 0
                ? retryAfter * 1000
                : 1000 * Math.pow(2, attempt) + Math.random() * 300,
              MAX_DELAY_MS,
            );

            if (response.status === 429 && attempt < MAX_RETRIES) {
              await new Promise((resolve) => setTimeout(resolve, delayMs));
              continue;
            }

            const error = new Error(
              `cart/add failed with status ${response.status}`,
            );
            error.cooldownMs = Math.max(delayMs, 2000);
            throw error;
          }

          return response.json();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      outOfStock() {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', location.href, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = xhr.responseText;
            let newCount = tempDiv.querySelector('.right-product-info');
            if (newCount) {
              document.querySelector('.right-product-info').innerHTML =
                newCount.innerHTML;
            }
          }
        };
        xhr.send();
      }
      toggleSubmitButton(disable = true, text) {
        if (this.selectButton != null) {
          this.selectButton.classList.remove('show');
          this.selectButton.classList.add('hide');
        }
        if (this.stickySelectButton != null) {
          this.stickySelectButton.classList.remove('show');
          this.stickySelectButton.classList.add('hide');
        }
        this.sendGiftButton = this.querySelector('.GiftWizard-gift-button');
        if (this.sendGiftButton) {
          this.sendGiftButton.classList.remove('gift-card-button');
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          this.outOfStock();
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.outOfStock();
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
